import React from 'react'
import { Form } from 'react-bootstrap'
import InputMask from 'react-input-mask';

import '../form-elem.css'

interface FormMaskedInputProps {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: () => void;
  onPaste?: (args: React.ClipboardEvent) => void;
  value: string;
  name: string;
  type: string;
  inputRef?: React.Ref<HTMLInputElement>;
  disabled?: boolean;
  placeholder?: string;
  error?: { message?: string };
  id?: string;
  mask: string;
  maskChar: string;
  maskPlaceholder?: string;
}

function FormMaskedInput({
  onChange,
  onBlur,
  onPaste,
  value,
  name,
  inputRef,
  disabled,
  type,
  placeholder,
  error,
  id,
  mask,
  maskPlaceholder: _maskPlaceholder,
}: FormMaskedInputProps) {
  return (
    <React.Fragment>
      <InputMask
        mask={mask}
        value={value}
        onChange={onChange}
        name={name}
        id={id}
        onBlur={onBlur}
        disabled={disabled}
        placeholder={placeholder}
        autoComplete={"no-auto-complete"}
        onPaste={onPaste}
      >
        {
          (inputProps: React.InputHTMLAttributes<HTMLInputElement>) => {
            const { size: _size, value: inputValue, ...restInputProps } = inputProps;
            const rawValue = inputValue as string | number | string[] | undefined;
            const normalizedValue = Array.isArray(rawValue) ? [...rawValue] : rawValue;
            return (
              <Form.Control
            type={type}
            {...restInputProps}
            value={normalizedValue}
            ref={inputRef}
          />
            );
          }
        }
      </InputMask>
      {
        error && error.message ? <>
          <Form.Control.Feedback type="invalid" >
            {error.message}
          </Form.Control.Feedback>
        </> : null
      }
    </React.Fragment>
  )
}

export default FormMaskedInput
